import { Injectable } from '@angular/core';
import { FilterParams, FilterResult, RepositoryService } from '../../helpers/crud/repository.service';
import { FilteredCampaign, TimeLineCampaign } from './model/campaigns.model';
import { WancomHttpService } from '../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../layout/waiting/waiting.service';
import { Campaign } from '../private-campaign/services/campaign.model';

@Injectable({
    providedIn: 'root',
})
export class CampaignService extends RepositoryService<Campaign> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'campaigns');
    }

    getFilteredCampaigndetails(input: InputFilterCampaigns) {
        return this.http.post<TimeLineCampaign[]>(
            `${this.url}/getFilteredCampaignDetails`,
            input
        );
    }

    getFilteredCampaigns(input: InputFilterCampaigns) {
        return this.http.post<FilteredCampaign>(
            `${this.url}/getFilteredCampaigns`,
            input
        );
    }

    getDiffusionDetail(diffusionId: number) {
        return this.http.get<OutputGetDiffusionDetail>(`${this.url}/getDiffusionDetail/${diffusionId}`);
    }

    getFacesForDiffusion(diffusionId: number, filterParams: FilterParams) {
        return this.http.get<FilterResult<DiffFaceInfos>>(`${this.url}/getFacesForDiffusion/${diffusionId}?page=${filterParams.page}&pageSize=${filterParams.pageSize}`);
    }
}

export interface InputFilterCampaigns extends FilterParams {
    startDate: string;
    endDate: string;
    tags?: number[];
    faceIds?: number[];
    search?: string;
    cId?: number;
    hidePermanent?: boolean;
}

export interface OutputGetDiffusionDetail {
    diffusionName: string;
    diffStartDate: string;
    diffEndDate: string;
    isPermanent: boolean;
    duration?: number;
    startHour?: string;
    endHour?: string;
    minTemp?: number;
    maxTemp?: number;
    weather?: string;
    diffusionDays: number[];
    spotId?: number;
    storageId?: string;
}

export interface DiffFaceInfos {
    screenId: number;
    screenName: string;
    screenAddress: string;
    zipCode: string;
    cityName: string;
    thumbnailId: string;
    storageId: string;
    screenTags: any[];
}
